// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"63ca9a10","554":"6eab6e8b","757":"15204a4f","857":"06f6d84d","998":"83312b1b"}[chunkId] + ".chunk.js";
};